var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { persistNSync } from 'persist-and-sync';
export var AGENT_PARTY_TYPE = 'Agent';
var initialChatState = {
    chatContactId: null,
    chatSkillId: null,
    isChatAccepted: false,
    messages: []
};
var getMessageKey = function (_a) {
    var TimeStamp = _a.TimeStamp, PartyType = _a.PartyType, Text = _a.Text;
    return "".concat(TimeStamp, "|").concat(PartyType, "|").concat(Text);
};
export var useChatStore = create()(subscribeWithSelector(persistNSync(function (set) { return (__assign(__assign({}, initialChatState), { setIncomingChat: function (contactId, skillId) {
        if (skillId === void 0) { skillId = null; }
        return set(__assign(__assign({}, initialChatState), { chatContactId: contactId, chatSkillId: skillId }));
    }, setChatAccepted: function (value) { return set({ isChatAccepted: value }); }, 
    // The transcript and get-next can both deliver the same message, and
    // every open tab receives get-next events, so messages are deduplicated
    addMessages: function (messages) {
        return set(function (state) {
            var keys = new Set(state.messages.map(getMessageKey));
            var newMessages = messages.filter(function (item) {
                var key = getMessageKey(item);
                if (keys.has(key))
                    return false;
                keys.add(key);
                return true;
            });
            if (!newMessages.length)
                return state;
            return {
                messages: __spreadArray(__spreadArray([], state.messages, true), newMessages, true).sort(function (a, b) { return Date.parse(a.TimeStamp) - Date.parse(b.TimeStamp); })
            };
        });
    }, resetChat: function () { return set(initialChatState); } })); }, {
    name: 'nic-chat-store',
    storage: 'localStorage',
    exclude: [/^set/, /^add/, /^reset/]
})));
export var selectChatContactId = function (state) {
    return state.chatContactId;
};
export var selectIsChatAccepted = function (state) {
    return state.isChatAccepted;
};
export var selectChatMessages = function (state) {
    return state.messages;
};
export var selectChatSkillId = function (state) {
    return state.chatSkillId;
};
